import React from 'react';
import {
    RoundsInfoHeader as Header,
    InfoHeaderSide as Side,
    InfoHeaderItem as Item,
    InfoHeaderRightSide as Right,
    ActionIconItem,
    ExerciseActionsRow,
    KebabMenuContainer,
    HeaderRow,
} from './style';
import { Text } from '../../../UI/Text';

export const InfoHeader = () => {
    return (
        <Header>
            <Side>
                <Heading marginRight={'20px'}>#</Heading>
                <Heading>Exercise</Heading>
            </Side>
            <Right>
                <HeaderRow>
                    <Item>
                        <Heading>Kms/h</Heading>
                    </Item>
                    <Item marginRight={'15px'}>
                        <Heading>Kms</Heading>
                    </Item>
                    <Item width={'80px'} marginRight={'30px'}>
                        <Heading>Time</Heading>
                    </Item>
                    <Item>
                        <Heading>Kg</Heading>
                    </Item>
                    <Item>
                        <Heading>Reps</Heading>
                    </Item>
                </HeaderRow>
                <ExerciseActionsRow>
                    <ActionIconItem />
                    <ActionIconItem />
                    <ActionIconItem />
                    <ActionIconItem />
                </ExerciseActionsRow>
                <KebabMenuContainer />
            </Right>
        </Header>
    );
};

const Heading = ({ children, ...props }) => (
    <Text {...props} uppercase={true} fontSize={12} weight={'bold'} opacity={0.7}>
        {children}
    </Text>
);



// WEBPACK FOOTER //
// ./src/UI/Containers/WorkoutPlan/RightBox/InfoHeader.js